// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"clinical-portal-3__GpDetails__moreInfo","consentQuickEdit":"clinical-portal-3__GpDetails__consentQuickEdit"};